<div class="header">Huge Connect Customer Portal Version Releases:</div>
<mat-card class="releases">
	<mat-card-content>
		@for (section of htmlSection; track section) {
<div
		
			class="notes">
			<div class="left-container">
				<span class="icon-container">
					<img
						src="../../../../assets/img/icon only.png"
						style="width: 24px; height: 24px" />
				</span>
				<span class="line"></span>
				<span class="title-container">
					<div
						[innerHtml]="section.header"
						class="title"></div>
				</span>
			</div>
			<div class="right-container">
				<div
					[innerHtml]="section.body"
					class="content"></div>
			</div>
		</div>
}
	</mat-card-content>
</mat-card>
